export default __webpack_public_path__ + "static/media/mobile_20s.917cebf7.jpg";